export default "__VITE_ASSET__97f10111__"